export default "__VITE_ASSET__054bf504__"